import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";

import LandingPage from "./components/LandingPage";
import PrivateRoute from "./components/PrivateRoute";
import Login from "./components/Login";
import ScrollToTop from "./components/ScrollToTop";

import ViewAllArticles from "./components/ViewAllArticles";
import ArticleDetail from "./components/ArticleDetail";
import ManageArticles from "./components/ManageArticles";
import CreateArticle from "./components/CreateArticle";

import ViewAllVideos from "./components/ViewAllVideos";
import ManageVideos from "./components/ManageVideos";

import ViewAllProjects from "./components/ViewAllProjects";
import ProjectDetail from "./components/ProjectDetail";
import ManageProjects from "./components/ManageProjects";
import CreateProject from "./components/CreateProject";
import EditProject from "./components/EditProject";
import EditArticle from "./components/EditArticle";

import InstagramDashboard from "./components/InstagramDashboard";
import GalleryDashboard from "./components/GalleryDashboard";
import ServicesPage from "./components/ServicesPage";

export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {/* Public */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />

        {/* Articles */}
        <Route path="/ViewArticles" element={<ViewAllArticles />} />
        <Route path="/articles/:name" element={<ArticleDetail />} />

        {/* Projects */}
        <Route path="/ViewProjects" element={<ViewAllProjects />} />
        <Route path="/projects/:name" element={<ProjectDetail />} />

        {/* Videos */}
        <Route path="/ViewVideos" element={<ViewAllVideos />} />

        {/* Services (public) */}
        <Route path="/services" element={<ServicesPage />} />

        {/* Admin — protected */}
        <Route
          path="/ArticlesDashboard"
          element={
            <PrivateRoute>
              <ManageArticles />
            </PrivateRoute>
          }
        />
        <Route
          path="/CreateArticle"
          element={
            <PrivateRoute>
              <CreateArticle />
            </PrivateRoute>
          }
        />
        <Route
          path="/EditArticle/:name"
          element={
            <PrivateRoute>
              <EditArticle />
            </PrivateRoute>
          }
        />
        <Route
          path="/VideosDashboard"
          element={
            <PrivateRoute>
              <ManageVideos />
            </PrivateRoute>
          }
        />
        <Route
          path="/ProjectsDashboard"
          element={
            <PrivateRoute>
              <ManageProjects />
            </PrivateRoute>
          }
        />
        <Route
          path="/CreateProject"
          element={
            <PrivateRoute>
              <CreateProject />
            </PrivateRoute>
          }
        />
        <Route
          path="/EditProject/:name"
          element={
            <PrivateRoute>
              <EditProject />
            </PrivateRoute>
          }
        />
        <Route
          path="/InstagramDashboard"
          element={
            <PrivateRoute>
              <InstagramDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/GalleryDashboard"
          element={
            <PrivateRoute>
              <GalleryDashboard />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
}
